import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';

@Injectable()
export class ContaCorrenteTerminalService {

  getPorId(itemId: any): Observable<HttpResponse<any>> {
    return this.http.get(
      environment.webApiSaguiControlUrl + '/api/contacorrenteterminal/visualiza/' + itemId, { observe: 'response' })
  }

  getPorcontaCorrenteId(itemId: any): Observable<HttpResponse<any>> {
    return this.http.get(
      environment.webApiSaguiControlUrl + '/api/contacorrenteterminal/visualizaporcontacorrente/' + itemId, { observe: 'response' })
  }

  getPorAdquirenciaId(itemId: any): Observable<HttpResponse<any>> {
    return this.http.get(
      environment.webApiSaguiControlUrl + '/api/contacorrenteterminal/visualizaporadquirencia/' + itemId, { observe: 'response' })
  }

  getPorcaixaId(itemId: any): Observable<HttpResponse<any>> {
    return this.http.get(
      environment.webApiSaguiControlUrl + '/api/contacorrenteterminal/visualizaporcaixa/' + itemId, { observe: 'response' })
  }

  post(item: any): Observable<HttpResponse<any>> {
    return this.http.post(
      environment.webApiSaguiControlUrl + '/api/contacorrenteterminal/inclui/', item, { observe: 'response' })
  };

  put(item: any, itemId: any): Observable<HttpResponse<any>> {
    return this.http.put(
      environment.webApiSaguiControlUrl + '/api/contacorrenteterminal/atualiza/' + itemId, item, { observe: 'response' })
  };

  delete(itemId: any): Observable<HttpResponse<any>> {
    return this.http.delete(
      environment.webApiSaguiControlUrl + '/api/contacorrenteterminal/exclui/' + itemId, { observe: 'response' })
  }
  constructor(private http: HttpClient, private sanitizer: DomSanitizer) {

  }
}
